import {RuleBundleType, RuleOrWorkflowBundleType} from '@frontapp/workflows/rules';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Dropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownList} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {SimpleDropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdownItem';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {ActivityPill} from '../activityPill/activityPill';
import {StyledActivityRulePillLearnMoreDiv, StyledActivityRulePillLinkIcon} from './activityRulePillHelpers';

/*
 * Props.
 */

interface ActivityRulePillProps {
  ruleId: number;
  ruleBundleId?: number;
  ruleBundleType?: RuleOrWorkflowBundleType;
  ruleName: string;
  isRuleAccessible: boolean;
  onActivityRuleClick: () => void;
  navigateToLink: (arg: string) => void;
}

const StyledPopoverCoordinator = styled(PopoverCoordinator)`
  display: flex;
  align-items: center;
`;

/*
 * Component.
 */

export const ActivityRulePill: FC<ActivityRulePillProps> = (props) => (
  <StyledPopoverCoordinator
    renderButton={(isOpen) => (
      <ActivityPill icon="gearFilledTiny" isOpen={isOpen}>
        {props.ruleName}
      </ActivityPill>
    )}
    renderModal={(popoverProps) => renderDropdown(popoverProps, props)}
  />
);

function renderDropdown(popoverProps: PopoverTransferProps, props: ActivityRulePillProps) {
  const {isRuleAccessible, onActivityRuleClick, navigateToLink} = props;
  const onLearnMoreClick = () => navigateToLink('https://help.front.com/t/m22445/understanding-rules');

  // We do not enable the rule link unless the user has access and this activity includes bundle details.
  const isEditDisabled = !isRuleAccessible || !props.ruleBundleId || !props.ruleBundleType;

  return (
    <Dropdown {...popoverProps} maxWidth={205}>
      <DropdownList {...popoverProps}>
        <SimpleDropdownItem isDisabled={isEditDisabled} onSelect={onActivityRuleClick}>
          {props.ruleBundleType === RuleBundleType.MACRO ? (
            <Trans id="activity-rule-macro-pill-edit">Edit macro</Trans>
          ) : (
            <Trans id="activity-rule-pill-edit">Edit rule</Trans>
          )}
        </SimpleDropdownItem>
        <SimpleDropdownItem onSelect={onLearnMoreClick}>
          <StyledActivityRulePillLearnMoreDiv>
            <Trans id="activity-rule-pill-help">
              Learn more about rules <StyledActivityRulePillLinkIcon name="externalLinkSmall" />
            </Trans>
          </StyledActivityRulePillLearnMoreDiv>
        </SimpleDropdownItem>
      </DropdownList>
    </Dropdown>
  );
}
